export default "__VITE_ASSET__BYhE7Zu5__"